import { TileLayerOptions } from "@mirage/components/gaiaMap/GaiaMap";
import MapFallback from "@mirage/components/MapView/components/MapFallback";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import NoGeometryMessage from "@publicPortal/components/noGeometryMessage/NoGeometryMessage";
import { PPConstants } from "@shared/publicportal/constants";
import { IEnforcementNoticeDetails } from "@shared/publicportal/contracts/IEnforcementNoticeDetails";
import { LatLngExpression } from "leaflet";
import { lazy, memo, Suspense, useMemo } from "react";
import { MapViewHelper } from "@mirage/components/MapView/MapViewHelper";
import { GeometryProjector } from "@shared/mirage/utils/GeometryProjector";

const GaiaMap = lazy(() =>
    import("@mirage/components/gaiaMap/GaiaMap").then((module) => {
        return { default: module.GaiaMap };
    })
);

export interface ENoticeMapTabProps {
    notice: IEnforcementNoticeDetails | null;
}
export const ENoticeMapTab = memo((props: ENoticeMapTabProps) => {
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const { clientSettings } = sessionValue;
    const geometry = props.notice?.enforcementReference?.geometry;
    const center: LatLngExpression | undefined = useMemo(() => {
        if (geometry) {
            const parsedGeometry = JSON.parse(geometry) as GeoJSON.Geometry;
            return MapViewHelper.GetCenterXYByGeometry(GeometryProjector.projectToWGS(parsedGeometry) as GeoJSON.Geometry);
        } else {
            return [clientSettings.MAP_CENTER_LAT, clientSettings.MAP_CENTER_LONG];
        }
    }, [clientSettings.MAP_CENTER_LAT, clientSettings.MAP_CENTER_LONG, geometry]);
    const masterLayer: TileLayerOptions | undefined = useMemo(
        () =>
            clientSettings
                ? {
                      layerUrl: clientSettings.MASTER_LAYER_URL,
                      attribution: clientSettings.MASTER_LAYER_ATTRIBUTION,
                  }
                : undefined,
        [clientSettings]
    );

    if (props.notice === null || props.notice.enforcementReference == null) {
        return null;
    }
    const mapView = <GaiaMap readOnly center={center} geometryJson={geometry} tileLayer={masterLayer} height={500} />;
    const component = props.notice.enforcementReference.geometry != null ? mapView : <NoGeometryMessage />;
    return <Suspense fallback={<MapFallback />}>{component}</Suspense>;
});
